<template>
  <section class="padding"> 

<div @click.self="closeModal"  class="modal-bg">
<div class="modal">
     
      <div class="footer">
           <div class="flex">
<div class="container1">
<!-- <h1>Become a teacher <br> and work with us!</h1>
<img src="../../assets/underline3.png" alt="">
<h4>Li’lyogisbysabrina@gmail.com <br> +91 99999 99999</h4>
<div class="icons">
<img src="../../assets/Socialicon1.png" alt="">
<img src="../../assets/Socialicon2.png" alt="">
<img src="../../assets/Socialicon3.png" alt="">
<img src="../../assets/Socialicon4.png" alt="">
</div> -->
<img src="../../assets/buynow_img.png" alt="">
</div>


<!-- <div class="modal-bg container3">
    <div class="modal">
        <h2>Quick Links</h2>
    <h4 class="child">Home</h4>
    <h4 class="child">Our Programs</h4>
    <h4 class="child">Become a teacher</h4>
    <button>Register</button>
    </div>
</div> -->


<div class="container3">
   <img @click="closeModal"  class="modal-close" src="../../assets/close_icon.png" alt="">
    <!-- <span @click="closeModal"  class="modal-close">X</span> -->
    <h3>Ocean yoga</h3>
    <h4 class="tag">₹ 1000</h4>
    <h4>Written by kids’ yoga expert, Sabrina <br> Merchant, Ocean Yoga is a picture book, an <br> activity book and a storybook all rolled into <br> one. About a vibrantly illustrated sailing trip, it <br> incorporates easy asanas that kids can try out. <br> A great bonding exercise for parents and kids! </h4>
    
    <button   >Buy Now!</button>
</div>
</div>
</div>
      </div>


      </div>
  </section>
</template>

<script>
export default {

props:["modalbg"],

methods:{
    closeModal(){
        this.$emit("close")
    }
}
}
</script>

<style scoped>
.tag{
    background-image: url(../../assets/tag1.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    color: #ca6500;
        width: 136px;
        text-align: center;
    /* height: 100%; */
}
h3{
    font-family: Original Surfer;
font-weight: 400;
font-size: 25px;
color: white;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 29px;
}
button:hover{
    background-color: #ca6500;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 100px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
.modal-close{
    position: absolute;
    top: 20px;
    right: 20px;
    font-weight: bold;
    color: white;
    cursor: pointer;
}
.modal-bg{
     /* position: fixed;
    top: 0;
    left: 0; */
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    /* visibility: hidden;
    opacity: 0; */
    transition: visibility 0s opacity 0.5s;
    z-index: 2000;
}

/* .bg-active{
    visibility: visible;
    opacity: 1;
} */

.modal{
    position: relative;
    background-color: #4BA3C3;
    width: 1340px;
    height: 589px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    border-radius: 20px;
    z-index: 10000;
}
.padding{
    margin-top: 150px;
}
.icons{
        display: flex;
    justify-content: space-between;
    width: 191px;
}

.container1{
        display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    height: 337px;
}

.container3{
        display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 401px;
    /* align-items: center; */
    align-items: start;
}

.child{
    color:  #D9DBE1;
}

.footer{
    width: 100%;
height: 406px;
/* background: #4BA3C3; */

}
.flex{
display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    /* padding-top: 36px; */

}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: white;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 200%;
}
h2{
    font-weight: 600;
    color: white;
}
@media(max-width: 850px){
    .modal{
        height: 893px;
    }
}
@media(max-width: 940px){
    .modal{
              height: 1068px;
    transform: scale(0.7);
    }
    .flex{
            position: relative;
    top: -338px;
    height: 1014px;
    }
    .modal-close{
            top: 56px;
    right: 14px;
    
    }
    .container1{
        align-items: center;
    }
    h1{
        text-align: center;
    }
    .modal-bg{
        /* position: absolute;
    top: 12px; */
        height: 749px;
    overflow-y: auto;
    }
    .modal-bg::-webkit-scrollbar { 
    display: none;
     -ms-overflow-style: none; 
    scrollbar-width: none; 
}
}
</style>